import PhoneInput from 'react-phone-number-input/input'
import styled, {css} from 'styled-components'
import {makeInputBaseStyle} from '../input-text/style'
import {SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'

export const StyledCallingCodeSelectTrigger = styled(SelectTrigger)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        white-space: nowrap;
        width: fit-content;
        font-weight: 400;
    `
)

export const StyledPhoneInput = styled(PhoneInput)(
    ({theme}) => css`
        ${makeInputBaseStyle(theme)}
    `
)
